'use client';

import React from 'react';
import { TrendingUp } from 'lucide-react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';

const data = [{ name: 'Occupancy', value: 78, fill: 'hsl(var(--primary))' }];

export default function OccupancyRateCard() {
  return (
    <div className="bg-white rounded-2xl border border-border shadow-card p-5 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full -translate-y-8 translate-x-8" />
      <div className="flex items-start justify-between mb-2 relative">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-1">
            Court Occupancy Rate
          </p>
          <p className="text-4xl font-bold text-foreground tabular-nums font-mono">78%</p>
          <div className="flex items-center gap-1.5 mt-1.5">
            <TrendingUp size={13} className="text-green-600" />
            <span className="text-xs font-semibold text-green-600">+6% vs last week</span>
          </div>
        </div>
        <div className="w-20 h-20 flex-shrink-0">
          <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
              cx="50%"
              cy="50%"
              innerRadius="60%"
              outerRadius="100%"
              startAngle={90}
              endAngle={-270}
              data={data}
            >
              <RadialBar dataKey="value" cornerRadius={6} background={{ fill: 'hsl(var(--muted))' }} />
            </RadialBarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <p className="text-xs text-muted-foreground relative">3 courts · Today</p>
    </div>
  );
}